import { render, staticRenderFns } from "./trapdataAnalyse.vue?vue&type=template&id=6c50b1ef&scoped=true&"
import script from "./trapdataAnalyse.vue?vue&type=script&lang=ts&"
export * from "./trapdataAnalyse.vue?vue&type=script&lang=ts&"
import style0 from "./trapdataAnalyse.vue?vue&type=style&index=0&id=6c50b1ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c50b1ef",
  null
  
)

export default component.exports